import gtm from './gtm-recorder';

export default [
  gtm, // google tag manager recorder
];
